import debounce from 'lodash.debounce';
import * as React from 'react';

import { projectsActionCreators } from 'src/actions/projects/actionCreators';
import { DiagramSnapshot } from 'src/containers/ProjectDiagram/types/diagram';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useHandleDiagramUpdate = () => {
  const dispatch = useReduxDispatch();
  const { projectId } = useRouterParams();

  const debouncedUpdateProjectDiagram =
    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useCallback(
      debounce(
        (diagram: DiagramSnapshot) => {
          dispatch(
            projectsActionCreators.updatedProjectDiagram(projectId, diagram)
          );
        },
        100,
        { leading: true, trailing: true }
      ),
      [dispatch, projectId]
    );

  return debouncedUpdateProjectDiagram;
};
